import React from 'react'

export default ({ ...props }) => (
  <svg width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M6.5 11.499C6.224 11.499 6 11.275 6 10.999V5C6 4.724 6.224 4.5 6.5 4.5H8C9.103 4.5 10 5.397 10 6.5C10 7.603 9.103 8.5 8 8.5H7V10.999C7 11.275 6.776 11.499 6.5 11.499ZM8 7.5C8.551 7.5 9 7.051 9 6.5C9 5.949 8.551 5.5 8 5.5H7V7.5H8Z'
      fill='#0D0D0D'
    />
    <path
      d='M11.5 11.5C11.224 11.5 11 11.276 11 11V5C11 4.724 11.224 4.5 11.5 4.5C13.43 4.5 15 6.07 15 8C15 9.93 13.43 11.5 11.5 11.5ZM12 10.449C13.141 10.214 14 9.188 14 8C14 6.812 13.141 5.785 12 5.55V10.449Z'
      fill='#0D0D0D'
    />
    <path
      d='M16.5 11.5C16.224 11.5 16 11.276 16 11V6C16 5.173 16.673 4.5 17.5 4.5H19.5C19.776 4.5 20 4.724 20 5C20 5.276 19.776 5.5 19.5 5.5H17.5C17.224 5.5 17 5.724 17 6V7.499H18.5C18.776 7.499 19 7.723 19 7.999C19 8.275 18.776 8.499 18.5 8.499H17V11C17 11.276 16.776 11.5 16.5 11.5Z'
      fill='#0D0D0D'
    />
    <path
      d='M1.5 15.499C0.673 15.499 0 14.826 0 13.999V1.999C0 1.172 0.673 0.499001 1.5 0.499001H22.5C23.327 0.499001 24 1.172 24 1.999V13.999C24 14.826 23.327 15.499 22.5 15.499H1.5ZM1.5 1.499C1.224 1.499 1 1.723 1 1.999V13.999C1 14.275 1.224 14.499 1.5 14.499H22.5C22.776 14.499 23 14.275 23 13.999V1.999C23 1.723 22.776 1.499 22.5 1.499H1.5Z'
      fill='#0D0D0D'
    />
  </svg>
)
